/* ============================================
   NIGHTLIFE FLOATING WHATSAPP INJECTOR
   Adds a sticky WhatsApp button to all pages
   ============================================ */

(function() {
  var WA_LINK = 'https://wa.me/33633952782';
  var WA_TOOLTIP = 'Contact us on WhatsApp';

  var SVG_WHATSAPP = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5 0 1.5 1.1 2.9 1.2 3.1.1.2 2.1 3.2 5.1 4.5 1.8.8 2.5.8 3.4.7.5-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.7.5 3.4 1.3 4.8L2 22l5.3-1.3c1.4.8 3 1.2 4.7 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm0 18c-1.5 0-3-.4-4.3-1.2l-.3-.2-3.2.8.8-3.1-.2-.3C3.9 14.9 3.5 13.5 3.5 12c0-4.7 3.8-8.5 8.5-8.5s8.5 3.8 8.5 8.5-3.8 8.5-8.5 8.5z"/></svg>';

  function inject() {
    if (document.querySelector('[data-pcn-wa-float]')) return;

    var a = document.createElement('a');
    a.className = 'pcn-wa-float';
    a.setAttribute('data-pcn-wa-float', '');
    a.href = WA_LINK;
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', WA_TOOLTIP);
    a.innerHTML = SVG_WHATSAPP + '<span class="pcn-wa-float__tooltip">' + WA_TOOLTIP + '</span>';

    document.body.appendChild(a);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
